/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfCommonCursorPaginationResponse, CommonCursorPaginationResponseFromJSONTyped, CommonCursorPaginationResponseToJSON, } from './CommonCursorPaginationResponse';
import { instanceOfCommonLimitOffsetPaginationResponse, CommonLimitOffsetPaginationResponseFromJSONTyped, CommonLimitOffsetPaginationResponseToJSON, } from './CommonLimitOffsetPaginationResponse';
export function CommonResponseCollectionPaginationFromJSON(json) {
    return CommonResponseCollectionPaginationFromJSONTyped(json, false);
}
export function CommonResponseCollectionPaginationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfCommonCursorPaginationResponse(json)) {
        return CommonCursorPaginationResponseFromJSONTyped(json, true);
    }
    if (instanceOfCommonLimitOffsetPaginationResponse(json)) {
        return CommonLimitOffsetPaginationResponseFromJSONTyped(json, true);
    }
    return {};
}
export function CommonResponseCollectionPaginationToJSON(json) {
    return CommonResponseCollectionPaginationToJSONTyped(json, false);
}
export function CommonResponseCollectionPaginationToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfCommonCursorPaginationResponse(value)) {
        return CommonCursorPaginationResponseToJSON(value);
    }
    if (instanceOfCommonLimitOffsetPaginationResponse(value)) {
        return CommonLimitOffsetPaginationResponseToJSON(value);
    }
    return {};
}
